import ctiProfile from './firms/cti/profile.json';
import ctiDiscount from './firms/cti/discount.json';
import ctiPricing from './firms/cti/pricing.json';

import ttpProfile from './firms/ttp/profile.json';
import ttpDiscount from './firms/ttp/discount.json';
import ttpPricing from './firms/ttp/pricing.json';

import e8Profile from './firms/e8/profile.json';
import e8Discount from './firms/e8/discount.json';
import e8Pricing from './firms/e8/pricing.json';

import fxifyProfile from './firms/fxify/profile.json';
import fxifyDiscount from './firms/fxify/discount.json';
import fxifyPricing from './firms/fxify/pricing.json';

import alphaProfile from './firms/alpha-capital/profile.json';
import alphaDiscount from './firms/alpha-capital/discount.json';
import alphaPricing from './firms/alpha-capital/pricing.json';

import forTradersProfile from './firms/for-traders/profile.json';
import forTradersDiscount from './firms/for-traders/discount.json';
import forTradersPricing from './firms/for-traders/pricing.json';

import seacrestProfile from './firms/seacrest-funded/profile.json';
import seacrestDiscount from './firms/seacrest-funded/discount.json';
import seacrestPricing from './firms/seacrest-funded/pricing.json';

import tradingPlusProfile from './firms/tradingplus/profile.json';
import tradingPlusDiscount from './firms/tradingplus/discount.json';
import tradingPlusPricing from './firms/tradingplus/pricing.json';

import wmtProfile from './firms/wmt/profile.json';
import wmtDiscount from './firms/wmt/discount.json';
import wmtPricing from './firms/wmt/pricing.json';

import blueberryfundedProfile from './firms/blueberryfunded/profile.json';
import blueberryfundedDiscount from './firms/blueberryfunded/discount.json';
import blueberryfundedPricing from './firms/blueberryfunded/pricing.json';

export const propFirmData = {
  cti: {
    ...ctiProfile,
    evaluation: {
      ...ctiProfile.evaluation,
      discount: ctiDiscount,
    },
    pricing: ctiPricing.challenges ?? (Array.isArray(ctiPricing) ? ctiPricing : []),
  },
  ttp: {
    ...ttpProfile,
    evaluation: {
      ...ttpProfile.evaluation,
      discount: ttpDiscount,
    },
    pricing: ttpPricing.challenges ?? (Array.isArray(ttpPricing) ? ttpPricing : []),
  },
  e8: {
    ...e8Profile,
    evaluation: {
      ...e8Profile.evaluation,
      discount: e8Discount,
    },
    pricing: e8Pricing.challenges ?? (Array.isArray(e8Pricing) ? e8Pricing : []),
  },
  fxify: {
    ...fxifyProfile,
    evaluation: {
      ...fxifyProfile.evaluation,
      discount: fxifyDiscount,
    },
    pricing: fxifyPricing.challenges ?? (Array.isArray(fxifyPricing) ? fxifyPricing : []),
  },
  'alpha-capital': {
    ...alphaProfile,
    evaluation: {
      ...alphaProfile.evaluation,
      discount: alphaDiscount,
    },
    pricing: alphaPricing.challenges ?? (Array.isArray(alphaPricing) ? alphaPricing : []),
  },
  'for-traders': {
    ...forTradersProfile,
    evaluation: {
      ...forTradersProfile.evaluation,
      discount: forTradersDiscount,
    },
    pricing: forTradersPricing.challenges ?? (Array.isArray(forTradersPricing) ? forTradersPricing : []),
  },
  'seacrest-funded': {
    ...seacrestProfile,
    evaluation: {
      ...seacrestProfile.evaluation,
      discount: seacrestDiscount,
    },
    pricing: seacrestPricing.challenges ?? (Array.isArray(seacrestPricing) ? seacrestPricing : []),
  },
  'tradingplus': {
    ...tradingPlusProfile,
    evaluation: {
      ...tradingPlusProfile.evaluation,
      discount: tradingPlusDiscount,
    },
    pricing: tradingPlusPricing.challenges ?? (Array.isArray(tradingPlusPricing) ? tradingPlusPricing : []),
  },
  'wmt': {
    ...wmtProfile,
    evaluation: {
      ...wmtProfile.evaluation,
      discount: wmtDiscount,
    },
    pricing: wmtPricing.challenges ?? (Array.isArray(wmtPricing) ? wmtPricing : []),
  },
  'blueberryfunded': {
    ...blueberryfundedProfile,
    evaluation: {
      ...blueberryfundedProfile.evaluation,
      discount: blueberryfundedDiscount,
    },
    pricing: blueberryfundedPricing.challenges ?? (Array.isArray(blueberryfundedPricing) ? blueberryfundedPricing : []),
  },
};
